import { render, staticRenderFns } from "./TopStoresRanking.vue?vue&type=template&id=1f707228&scoped=true&"
import script from "./TopStoresRanking.vue?vue&type=script&lang=js&"
export * from "./TopStoresRanking.vue?vue&type=script&lang=js&"
import style0 from "./TopStoresRanking.vue?vue&type=style&index=0&id=1f707228&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f707228",
  null
  
)

export default component.exports